import axios from "axios";

const USER_TOKEN = localStorage.getItem("token");
const AuthStr = "Bearer ".concat(USER_TOKEN);
console.log(process.env.REACT_APP_BASE_URL);
console.log(process.env.NODE_ENV);
let url = process.env.NODE_ENV == '' ? process.env.REACT_APP_BASE_URL : 'http://localhost:4000'
const api = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  headers: { Authorization: AuthStr }
});

// Request interceptor to add current token to headers
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle authentication errors
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      // Check if it's a company deactivation error
      if (error.response.data && error.response.data.error === 'COMPANY_DEACTIVATED') {
        alert(error.response.data.message || 'Sua empresa foi desativada. Entre em contato com o administrador.');
      } else {
        alert('Sua sessão expirou. Você será redirecionado para o login.');
      }
      
      // Clear all authentication data from localStorage
      localStorage.removeItem("token");
      localStorage.removeItem("CompanyId");
      localStorage.removeItem("name");
      localStorage.removeItem("email");
      localStorage.removeItem("userId");
      localStorage.removeItem("UserTypeId");
      localStorage.removeItem("SectorId");
      localStorage.removeItem("businessName");
      localStorage.removeItem("cnpj");
      localStorage.removeItem("CompanyTypeId");
      localStorage.removeItem("companyStatusId");
      localStorage.removeItem("companyStatus");
      
      // Redirect to login page
      window.location.href = "/";
    }
    
    return Promise.reject(error);
  }
);

export default api;
